export default {
  purchasesData: {}
}